import React, { useCallback, useEffect, useState } from 'react';
import { ShoppingBagIcon, XIcon, CheckCircle2Icon } from 'lucide-react';
const names = ['Martín G.', 'Lucas R.', 'Florencia M.', 'Diego S.', 'Carla P.', 'Sebastián V.', 'Jimena L.', 'Andrés M.', 'Valeria T.'];
const cities = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'Buenos Aires', 'Santa Fe', 'Tucumán', 'La Plata', 'Mar del Plata'];
const timeAgo = ['hace 2 minutos', 'hace 4 minutos', 'hace 6 minutos', 'hace 8 minutos', 'hace 12 minutos', 'hace 15 minutos'];
function getRandomItem<T>(arr: T[]): T {
  return arr[Math.floor(Math.random() * arr.length)];
}
export function SocialProofPopup() {
  const [mounted, setMounted] = useState(false);
  const [animate, setAnimate] = useState(false);
  const [data, setData] = useState({
    name: '',
    city: '',
    time: ''
  });
  const hidePopup = useCallback(() => {
    setAnimate(false);
    setTimeout(() => setMounted(false), 400);
  }, []);
  const showNotification = useCallback(() => {
    const index = Math.floor(Math.random() * names.length);
    setData({
      name: names[index],
      city: cities[index],
      time: getRandomItem(timeAgo)
    });
    setMounted(true);
    requestAnimationFrame(() => {
      requestAnimationFrame(() => setAnimate(true));
    });
    setTimeout(hidePopup, 5000);
  }, [hidePopup]);
  useEffect(() => {
    const initialTimer = setTimeout(showNotification, 5000);
    const interval = setInterval(showNotification, 180000);
    return () => {
      clearTimeout(initialTimer);
      clearInterval(interval);
    };
  }, [showNotification]);
  if (!mounted) return null;
  return <div className="fixed bottom-6 left-6 z-50 max-w-xs" style={{
    transform: animate ? 'translateX(0)' : 'translateX(-110%)',
    opacity: animate ? 1 : 0,
    transition: 'transform 0.4s cubic-bezier(0.34, 1.56, 0.64, 1), opacity 0.3s ease'
  }} data-id="element-457">
      <div className="bg-card-dark border-l-4 border-l-success rounded-r-xl rounded-l-sm shadow-[0_4px_24px_rgba(0,0,0,0.5)] p-4 flex items-start gap-3 relative" data-id="element-458">
        <button onClick={hidePopup} className="absolute top-2 right-2 w-5 h-5 flex items-center justify-center text-gray-400 hover:text-white transition-colors" aria-label="Cerrar" data-id="element-459">
          <XIcon className="w-3.5 h-3.5" data-id="element-460" />
        </button>

        <div className="w-10 h-10 rounded-full bg-success/10 flex items-center justify-center shrink-0 mt-1" data-id="element-461">
          <ShoppingBagIcon className="w-5 h-5 text-success" data-id="element-462" />
        </div>

        <div className="pr-4" data-id="element-463">
          <div className="flex items-center gap-1 mb-1" data-id="element-464">
            <CheckCircle2Icon className="w-3 h-3 text-success" data-id="element-465" />
            <span className="text-[10px] font-bold text-success uppercase tracking-wider" data-id="element-466">
              Compra Verificada
            </span>
          </div>
          <p className="text-sm text-gray-300 leading-tight" data-id="element-467">
            <span className="text-white font-bold" data-id="element-468">{data.name}</span> de{' '}
            {data.city} compró el{' '}
            <span className="text-primary font-semibold" data-id="element-469">Pack Élite</span>
          </p>
          <p className="text-[11px] text-gray-500 mt-1" data-id="element-470">{data.time}</p>
        </div>
      </div>
    </div>;
}